export const detectEngSymbols = (text: string) => (/[a-z]+/ig).test(text);
